import { observable, action } from 'mobx'
import { browserHistroy } from 'react-router'

import Ds from './ds'

class Globals {
  /**
   * Observables
   **/
  @observable baseUrl = 'http://localhost:3000'
  @observable taxRate = 0.0875
  @observable loggedIn = false
  @observable currentPage = 'dashboard'
  @observable currentSubPage = 'organizations'
  @observable ds = new Ds()
  @observable loggedInUser = {
    id: 0,
    organizationId: 0,
    userName: '',
    firstName: '',
    lastName: '',
    accessLevel: 0
  }
  /*
  @observable loggedInUser = {
    id: 1,
    organizationId: 1,
    userName: 'nmuratore',
    firstName: 'Nick',
    lastName: 'Muratore',
    accessLevel: 15
  }
  */

  /**
   * Actions
   **/
  @action taxRateByZipCode(zipCode, callback) {
    const query = `{
      taxRateByZipCode(zipCode: "${ zipCode }") { taxRate }
    }`
    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        callback(data.taxRateByZipCode)
      }
    })
  }

  @action setCurrentPage(newPage) {
    this.currentPage = newPage
  }

  @action setCurrentSubPage(newSubPage) {
    this.currentSubPage = newSubPage
  }

  @action setLoggedInUser(newUser) {
    this.loggedInUser = {
      id: newUser.user.id,
      organizationId: newUser.user.organizationId,
      userName: newUser.user.username,
      firstName: newUser.user.firstName,
      email: newUser.user.email,
      lastName: newUser.user.lastName,
      accessLevel: newUser.user.accessLevel
    }
    this.loggedIn = true

    localStorage.setItem('userId', newUser.user.id)
    localStorage.setItem('userOrganizationId', newUser.user.organizationId)
    localStorage.setItem('userName', newUser.user.username)
    localStorage.setItem('userFirstName', newUser.user.firstName)
    localStorage.setItem('userLastName', newUser.user.lastName)
    localStorage.setItem('userEmail', newUser.user.email)
    localStorage.setItem('userAccessLevel', newUser.user.accessLevel)
    localStorage.setItem('userHash', newUser.hash)
  }

  @action logout() {
    this.loggedInUser = {}
    this.loggedIn = false
    localStorage.setItem('userId', 0)
    localStorage.setItem('userOrganizationId', 0)
    localStorage.setItem('userName', '')
    localStorage.setItem('userFirstName', '')
    localStorage.setItem('userLastName', '')
    localStorage.setItem('userEmail', '')
    localStorage.setItem('userAccessLevel', 0)
    localStorage.setItem('userHash', '')
    window.location.reload()
  }
}

export default new Globals()



// WEBPACK FOOTER //
// ./src/stores/globals.js